import AboutUse from './AboutUse.vue'

export default AboutUse
